<div class="ph-cropper" #cropper [ngClass]="{ 'ph-cropper--load': loading }">
  <p-dialog
    [(visible)]="displayCropperModal"
    [modal]="true"
    (onHide)="displayCropperModal = false"
    [style]="{ maxWidth: '1400px' }"
    [closeOnEscape]="false"
  >
    <div style="padding: 40px 80px">
      <div class="modal__wrapper modal__wrapper--lg" [ngClass]="{ 'cropper--loading': loading }">
        <div class="img-container">
          <img id="image" src="" #cropperImg />
        </div>
        <div class="modal__actions">
          <button class="btn btn--outline btn--md" (click)="cancel()">
            {{ 'GLOBAL.cancel' | translate }}
          </button>
          <button class="btn btn--primary btn--md" (click)="rotate()">
            <i class="zmdi zmdi-rotate-cw"></i>
          </button>
          <button class="btn btn--primary btn--md" (click)="reset()">
            {{ 'GLOBAL.cropper_reset' | translate }}
          </button>
          <button class="btn btn--primary btn--md" (click)="crop()">
            {{ 'GLOBAL.save_changes' | translate }}
          </button>
        </div>
      </div>
    </div>
  </p-dialog>
</div>
